// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as SocialTelegramComponent} from './SocialTelegram.svg';

import Icon, { TIconProps } from '../Icon';

export const IconSocialTelegram = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <SocialTelegramComponent/>
  </Icon>
));
